import { useApiClient } from '../client'

export const GET_USER_BUSINESSES_ENDPOINT = '/core/v2/business_api/me/businesses'

import type { UserBusinessesResponse } from '@/api/types/user-businesses'

export function getUserBusinesses () {
  const apiClient = useApiClient()

  return apiClient.get<UserBusinessesResponse>({
    url: GET_USER_BUSINESSES_ENDPOINT,
  })
}
